import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  baseURL: typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3004',
  basePath: '/api/student-auth',
})

export const { signIn, signUp, signOut, useSession } = authClient
